import { BareButton } from '@calendly/ui/components/bare-button';
import { BrandLogo } from '@calendly/ui/components/brand-logo';
import { ArrowChevronRightMiniIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { TRACKING_EVENT_NAMES } from '../../hooks/analytics_events/constants';
import { useTrack } from '../../hooks/analytics_events/useTrack';
import { useBrowserName } from '../../hooks/useBrowserName';
import { getCtaDestination, isUnsupportedBrowser } from '../../shared/browsers/helpers';
function openSidebar(tabName) {
  window.top?.postMessage({
    action: 'open',
    component: 'sidebar',
    tabName
  }, '*');
}
export const variants = {
  contacts: {
    copy: <BodyText>
        Schedule your
        {' '}
        <BodyText inline weight="bold">contacts</BodyText>
        {' '}
        from anywhere
      </BodyText>,
    ctaText: 'contacts_open_extension',
    tab: 'contacts'
  },
  meetings: {
    copy: <BodyText>
        One click access to your
        {' '}
        <BodyText inline weight="bold">meetings</BodyText>
      </BodyText>,
    ctaText: 'meetings_open_extension',
    tab: 'meetings'
  },
  schedulingLinks: {
    copy: <BodyText>
        One click access to your
        {' '}
        <BodyText inline weight="bold">scheduling links</BodyText>
      </BodyText>,
    ctaText: 'ets_open_extension',
    tab: 'event_types'
  }
};
const styledLogoCss = "snfgku8";
const StyledLogo = forwardRef((props, ref) => <BrandLogo ref={ref} {...props} className={classNames(styledLogoCss, props.className)} />);
const styledButtonCss = "sbkym10";
const StyledButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(styledButtonCss, props.className)} />);
export const ExtensionReengageCta = ({
  copy,
  tab,
  ctaText
}) => {
  const browserName = useBrowserName();
  const track = useTrack();
  const ctaDestination = getCtaDestination(browserName);
  const onClick = () => {
    openSidebar(tab);
    if (!isUnsupportedBrowser()) {
      track({
        name: TRACKING_EVENT_NAMES.CTA_CLICKED,
        entities: ['attribution', 'organization', 'user'],
        properties: {
          cta_text: ctaText,
          cta_key: 'header',
          cta_destination: ctaDestination
        }
      });
    }
  };
  useEffect(() => {
    if (!isUnsupportedBrowser()) {
      track({
        name: TRACKING_EVENT_NAMES.CTA_SHOWN,
        entities: ['attribution', 'organization', 'user'],
        properties: {
          cta_text: ctaText,
          cta_key: 'header',
          cta_destination: ctaDestination
        }
      });
    }
  }, [ctaDestination, ctaText, track]);
  return <StyledButton onClick={onClick}>
      <StyledLogo name={browserName} />
      {copy}
      <ArrowChevronRightMiniIcon />
    </StyledButton>;
};

require("./extension_reengage_cta.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./extension_reengage_cta.js");